import { z } from 'zod/v4';

/**
 * Install a fallback error map on the backend's zod instance. The frontend bundles the
 * backend's drizzle-zod schemas, and those run on this instance, not the frontend's, so the
 * frontend calls this to give them the same fallback messages as its own schemas.
 *
 * @param customError - The fallback map; returning undefined keeps zod's own message
 */
export function configureZodErrors(customError: NonNullable<Parameters<typeof z.config>[0]>['customError']): void {
  z.config({ customError });
}
